export function linkToTutorialPage() {
  return "/tutorial";
}
